var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHot2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4821_16925",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 11,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.054 7.79418C13.7633 7.13335 13.3471 6.54781 12.8176 6.05587L12.3836 5.65291C12.3195 5.59562 12.2181 5.6212 12.1898 5.70276L11.9959 6.26553C11.875 6.61863 11.6529 6.97917 11.3382 7.33393C11.3222 7.35142 11.3003 7.36215 11.277 7.36413C11.2533 7.36628 11.23 7.35802 11.2128 7.34152C11.1919 7.32352 11.1815 7.29628 11.1831 7.26905C11.2383 6.36061 10.9699 5.33612 10.3821 4.22115C9.89584 3.29473 9.2203 2.57183 8.37604 2.068L7.76004 1.7012C7.67944 1.65282 7.57663 1.71622 7.58104 1.8113L7.61384 2.53551C7.63619 3.03043 7.57957 3.46805 7.44528 3.83173C7.28113 4.27678 7.0455 4.69031 6.74428 5.06141C6.53248 5.32093 6.29538 5.55485 6.03594 5.75707C5.40804 6.24439 4.89045 6.87962 4.53994 7.59029C4.1865 8.30873 4 9.113 4 9.91876C4 10.6309 4.1387 11.3204 4.41316 11.9709C4.67864 12.5971 5.05738 13.1615 5.53923 13.6441C6.02239 14.127 6.58323 14.5072 7.20819 14.7714C7.8555 15.0459 8.54166 15.1847 9.25016 15.1847C9.95851 15.1847 10.6447 15.0459 11.292 14.7728C11.917 14.5087 12.4792 14.13 12.961 13.6457C13.4441 13.1627 13.823 12.5985 14.0869 11.9722C14.3614 11.322 14.5 10.6322 14.5 9.92025C14.5 9.18382 14.3509 8.46869 14.054 7.79418Z",
    fill: "url(#paint0_linear_4821_16925)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4821_16925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.054 7.79418C13.7633 7.13335 13.3471 6.54781 12.8176 6.05587L12.3836 5.65291C12.3195 5.59562 12.2181 5.6212 12.1898 5.70276L11.9959 6.26553C11.875 6.61863 11.6529 6.97917 11.3382 7.33393C11.3222 7.35142 11.3003 7.36215 11.277 7.36413C11.2533 7.36628 11.23 7.35802 11.2128 7.34152C11.1919 7.32352 11.1815 7.29628 11.1831 7.26905C11.2383 6.36061 10.9699 5.33612 10.3821 4.22115C9.89584 3.29473 9.2203 2.57183 8.37604 2.068L7.76004 1.7012C7.67944 1.65282 7.57663 1.71622 7.58104 1.8113L7.61384 2.53551C7.63619 3.03043 7.57957 3.46805 7.44528 3.83173C7.28113 4.27678 7.0455 4.69031 6.74428 5.06141C6.53248 5.32093 6.29538 5.55485 6.03594 5.75707C5.40804 6.24439 4.89045 6.87962 4.53994 7.59029C4.1865 8.30873 4 9.113 4 9.91876C4 10.6309 4.1387 11.3204 4.41316 11.9709C4.67864 12.5971 5.05738 13.1615 5.53923 13.6441C6.02239 14.127 6.58323 14.5072 7.20819 14.7714C7.8555 15.0459 8.54166 15.1847 9.25016 15.1847C9.95851 15.1847 10.6447 15.0459 11.292 14.7728C11.917 14.5087 12.4792 14.13 12.961 13.6457C13.4441 13.1627 13.823 12.5985 14.0869 11.9722C14.3614 11.322 14.5 10.6322 14.5 9.92025C14.5 9.18382 14.3509 8.46869 14.054 7.79418Z",
    fill: "url(#paint1_linear_4821_16925)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4821_16925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94698 19.6846C11.8345 17.2197 12.212 15.1346 11.9041 13.4648C11.3304 10.3542 8.37811 8.68457 8.37811 8.68457C8.37811 8.68457 9.59835 10.7601 6.80925 13.8733C4.89177 16.1563 6.98358 19.6846 6.98358 19.6846H9.94698Z",
    fill: "url(#paint2_linear_4821_16925)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4821_16925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 14.0406C6.03447 15.0984 6.61755 15.9975 7.43172 16.5088L10.1963 16.6846C11.3293 16.1562 12.0771 14.9227 11.9937 13.5814C11.9444 12.8048 11.5122 12.0644 11.0447 11.5531C10.7622 13.5111 9.74693 13.7401 9.74693 13.7401C9.74693 13.7401 10.33 12.4533 10.4124 11.0247C10.4627 10.4601 10.4284 9.85917 10.2626 9.2594C9.72981 7.23106 8.814 6.68457 8.814 6.68457C8.814 6.68457 9.11356 7.86598 8.01587 9.77074C7.24878 11.095 5.95316 12.0644 6.0013 14.0406Z",
    fill: "url(#paint3_linear_4821_16925)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 14.0406C6.03447 15.0984 6.61755 15.9975 7.43172 16.5088L10.1963 16.6846C11.3293 16.1562 12.0771 14.9227 11.9937 13.5814C11.9444 12.8048 11.5122 12.0644 11.0447 11.5531C10.7622 13.5111 9.74693 13.7401 9.74693 13.7401C9.74693 13.7401 10.33 12.4533 10.4124 11.0247C10.4627 10.4601 10.4284 9.85917 10.2626 9.2594C9.72981 7.23106 8.814 6.68457 8.814 6.68457C8.814 6.68457 9.11356 7.86598 8.01587 9.77074C7.24878 11.095 5.95316 12.0644 6.0013 14.0406Z",
    fill: "url(#paint4_linear_4821_16925)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4821_16925)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7.68457,
    r: 1,
    fill: "#FFFBE0"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5559 1.53835C10.4519 1.30796 10.4138 1.01457 10.5634 0.80399C11.322 0.810172 11.7653 1.34159 11.8921 1.60653C11.9646 1.72105 12.0198 1.85384 12.042 2.00274C12.1239 2.50283 11.9525 2.73356 11.9525 2.73356C11.9525 2.73356 11.9021 2.44362 11.425 2.17264C11.0923 1.98473 10.7536 1.96703 10.5559 1.53835Z",
    fill: "url(#paint5_linear_4821_16925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4821_16925",
    x: 2,
    y: 4.68457,
    width: 14,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4821_16925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4821_16925",
    x: 4,
    y: 4.68457,
    width: 10,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_4821_16925"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4821_16925",
    x: 5,
    y: 3.68457,
    width: 8,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_4821_16925"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4821_16925",
    x1: 5.4748,
    y1: 2.13531,
    x2: 9.75037,
    y2: 15.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF361C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF624D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4821_16925",
    x1: 8,
    y1: 2.18457,
    x2: 9.75037,
    y2: 15.1191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4821_16925",
    x1: 9,
    y1: 8.68457,
    x2: 9,
    y2: 19.6846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF88B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF103",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4821_16925",
    x1: 9,
    y1: 6.68457,
    x2: 9,
    y2: 16.6846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF88B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF103",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4821_16925",
    x1: 9,
    y1: 6.68457,
    x2: 9,
    y2: 16.6846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF88B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF103",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4821_16925",
    x1: 11.6691,
    y1: 2.77722,
    x2: 11.108,
    y2: 0.608876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE2E16"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot2);
export default __webpack_public_path__ + "static/media/hot-2.0df69e8fd417b1935084ed586a82db49.svg";
export { ForwardRef as ReactComponent };